import { Message } from "element-ui"
export function onTip(isFlag,message) {
  if (!isFlag) {
    let  msg = message ? (message + ' ~') : "提交审核暂未通过，暂无权限，加急审核中~"
        Message.error(msg )
        return true
  } else {
    return false
            }
}